<div class="main-content table-page incidencia-cliente-inbox-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Bandeja de incidencias cliente</h1>
        <p>Revise reportes recibidos desde clientes e impórtelos al flujo de QA cuando deban atenderse.</p>
      </div>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Buscar</mat-label>
              <input
                matInput
                aria-label="Buscar"
                [(ngModel)]="textoBusqueda"
                (keyup.enter)="buscar()"
                placeholder="Título de la incidencia" />
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Proyecto</mat-label>
              <mat-select [(ngModel)]="selectProyecto" (selectionChange)="buscar()">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let proyecto of proyectos" [value]="proyecto.id">
                  {{ proyecto.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Estatus</mat-label>
              <mat-select [(ngModel)]="selectEstatus" (selectionChange)="buscar()">
                <mat-option [value]="null">Todos</mat-option>
                <mat-option *ngFor="let estatus of estatusOptions" [value]="estatus">
                  {{ estatus }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--narrow">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Prioridad</mat-label>
              <mat-select [(ngModel)]="selectPrioridad" (selectionChange)="buscar()">
                <mat-option [value]="null">Todas</mat-option>
                <mat-option *ngFor="let prioridad of prioridadOptions" [value]="prioridad">
                  {{ prioridad }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--narrow">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Desde</mat-label>
              <input matInput type="date" aria-label="Desde" [(ngModel)]="fechaIni" (change)="buscar()" />
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--narrow">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Hasta</mat-label>
              <input matInput type="date" aria-label="Hasta" [(ngModel)]="fechaFin" (change)="buscar()" />
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="limpiarFiltros()">
            <span class="material-icons">filter_alt_off</span>
            Limpiar
          </button>
          <label class="table-page__page-size">
            <span>Registros</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>
      </div>

      <div class="table-page__table-wrap" *ngIf="incidencias.length > 0; else emptyTpl">
        <table class="table-page__table table-page__table--wide">
          <thead>
            <tr>
              <th>Folio</th>
              <th>Incidencia</th>
              <th>Cliente</th>
              <th>Estatus</th>
              <th>Prioridad</th>
              <th>Fecha</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let incidencia of incidencias">
              <td>#{{ incidencia.id_incidencia_proyecto || incidencia.id }}</td>
              <td>
                <span class="table-page__name">{{ incidencia.titulo }}</span>
                <span class="table-page__subtext">{{ incidencia.descincidencia }}</span>
              </td>
              <td>{{ incidencia.nombreCliente || 'Sin cliente' }}</td>
              <td><span class="table-page__status-badge">{{ incidencia.estatus }}</span></td>
              <td>{{ incidencia.prioridad }}</td>
              <td>{{ incidencia.fecha_creacion }}</td>
              <td class="table-page__actions">
                <button
                  type="button"
                  mat-raised-button
                  class="btn table-page__icon-btn table-page__icon-btn--secondary"
                  [disabled]="incidencia.importada || importingId === incidencia.id"
                  (click)="importar(incidencia)">
                  <span class="material-icons">input</span>
                  {{ importingId === incidencia.id ? 'Importando' : 'Importar a QA' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-page__footer" *ngIf="totalRegistros > 0">
        <div class="table-page__meta">Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ rangeEnd }} de {{ totalRegistros }}</div>
        <div class="table-page__pager">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage <= 1">«</button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage <= 1">‹</button>
          <ng-container *ngFor="let page of getPaginationItems()">
            <button
              *ngIf="isPageNumber(page); else ellipsisTpl"
              type="button"
              class="table-page__pager-page"
              [class.is-current]="page === currentPage"
              (click)="onPageChange(page)">
              {{ page }}
            </button>
          </ng-container>
          <ng-template #ellipsisTpl>
            <span class="table-page__pager-ellipsis">...</span>
          </ng-template>
          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage >= totalPages">›</button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage >= totalPages">»</button>
        </div>
      </div>

      <ng-template #emptyTpl>
        <div class="table-page__empty-state">
          <span class="material-icons">inbox</span>
          <p>No hay incidencias cliente pendientes de importar.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
